import { StyledModalWrapper, ModalContainer } from './styles';
import React from 'react';
import { QuickCheckoutContent } from './quick-checkout-content';
import { useQuickCheckoutHeight } from 'components/payment/quick-checkout/useQuickCheckoutHeight.hook';
import { useSearchParams } from 'hooks/use-search-params.hook';
import { searchParams } from 'shared/types/search-params';

import { MultidayCheckoutContainer } from 'components/payment/quick-checkout/components/multiday-checkout-content/multidayCheckoutContainer';
import useKioskEnabled from 'store/kiosk/hooks/use-kiosk-enabled';

interface QuickCheckoutProps {
  closeQuickCheckoutHandler: VoidFunction;
  reverseAnimation: boolean;
  openCheckout?: (expandAddCard?: boolean) => void;
  overflow?: string;
}

export const QuickCheckout = ({
  closeQuickCheckoutHandler,
  reverseAnimation,
  openCheckout,
  overflow,
}: QuickCheckoutProps) => {
  const quickCheckoutHeight = useQuickCheckoutHeight();
  const { startDates } = useSearchParams<searchParams>();
  const isMultiDayContent = !!startDates?.length;
  const isKiosk = useKioskEnabled();

  const buildContent = (): JSX.Element => (
    <ModalContainer kioskMode={isKiosk}>
      <QuickCheckoutContent closeQuickCheckoutHandler={closeQuickCheckoutHandler} openCheckout={openCheckout} />
    </ModalContainer>
  );

  return isMultiDayContent ? (
    <MultidayCheckoutContainer
      closeQuickCheckoutHandler={closeQuickCheckoutHandler}
      reverseAnimation={reverseAnimation}
    />
  ) : (
    <StyledModalWrapper
      reverseAnimation={reverseAnimation}
      quickCheckoutHeight={quickCheckoutHeight}
      content={buildContent()}
      overflow={overflow}
      kioskMode={isKiosk}
    />
  );
};
